import { ArterialStiffnessRiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<ArterialStiffnessRiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [
        ArterialStiffnessRiskLevel.Low,
        [
          {
            lower: 860,
            upper: 1650,
          },
        ],
      ],
      [
        ArterialStiffnessRiskLevel.High,
        [
          {
            lower: 1650,
            upper: 3400,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
